import React, {useState, useEffect} from "react"
import "../App.css"
import axios from "axios"
import AddForms from "./AddForms"
import LoginRequest from "./LoginRequest"
import ChangeCarInfo from "./ChangeCarInfo"
import {SERVER_URI, URL_EXTENSION} from "../utility/config"
import {Link} from "react-router-dom"
import {Box, Checkbox, Modal} from "@material-ui/core"
import Typography from "@material-ui/core/Typography"

function CarsAndDrivers(props) {
	props.stopListRefresh()
	const [show, setShow] = useState({})
	const [isloggedIn, setIsloggedIn] = useState(true)
	const [popupInfo, setPopupInfo] = useState("")
	const [isOpenCar, setIsOpenCar] = useState(false)
	let storage = window.localStorage
	let userToken = storage.getItem("admin_token")
	const [editCarIndex, setEditCarIndex] = useState(null)
	const [showCarAvailability, setShowCarAvailability] = useState(false)
	const [selectedCar, setSelectedCar] = useState(null)

	console.log("PRIORITY GROUPS:", props.priorityGroups)
	useEffect(() => {
		const fetchLogin = async () => {
			if (userToken === null) {
				console.log("kirjaudu sisään")
				setIsloggedIn(false)
			}
		}
		fetchLogin()
		// DON'T DELETE THE COMMENT BELOW!!
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [])

	const toggleComment = (id) => {
		setShow((prevShow) => ({...prevShow, [id]: !prevShow[id]}))
	}

	const togglePopupCar = (car, index) => {
		setEditCarIndex(index)
		setIsOpenCar(!isOpenCar)
		let carInfo = {
			registerPlate:          car.registerPlate,
			vehicleId:              car.vehicleId,
			phoneNumber:            car.phoneNumber,
			numberOfSeats:          car.numberOfSeats,
			priorityGroup:          car.priorityGroup,
			availableForDayShift:   car.availableForDayShift,
			availableForNightShift: car.availableForNightShift,
			availableForWeekendDayShift: car.availableForWeekendDayShift,
			availableForWeekendNightShift: car.availableForWeekendNightShift,
		}
		setPopupInfo(carInfo)
	}
	const togglePopupUpdateCar = (car) => {
		setIsOpenCar(!isOpenCar)
	}

	const deleteDriver = async (driver, index) => {
		let Id = driver.driverId
		try {
			await axios.delete(`${SERVER_URI}/remove_driver/${Id}`, {
				headers: {Authorization: `Token ${userToken}`},
			})
			props.dispatch({type: "DELETE_DRIVER", data: {driverIndex: index}})
		} catch (e) {
			console.log(e.response.data.error)
			alert(`Virhe kuljettajan poistossa:\n${e.response.data.error}`)
		}
	}

	const deleteCar = async (car, index) => {
		let Id = car.vehicleId
		try {
			await axios.delete(`${SERVER_URI}/remove_vehicle/${Id}`, {
				headers: {Authorization: `Token ${userToken}`},
			})
			props.dispatch({type: "DELETE_CAR", data: {vehicleIndex: index}})
		} catch (e) {
			alert(`Virhe ajoneuvon poistosssa\n${e.response.data.error}`)
		}
	}

	const handleResetDriversPassword = async (driverId) => {
		try {
			await axios({
				method:  "PUT",
				url:     `${SERVER_URI}/reset_driver_password/${driverId}`,
				headers: {Authorization: `Token ${userToken}`},
			})
			alert("Kuljettajan salasana on nollattu onnistuneesti!")
		} catch (e) {
			console.log(e.response.data.error)
			alert(`Virhe kuljettajan salasanan nollauksessa:\n${e.response.data.error}`)
		}
	}

	const handleShowCarAvailability = (car) => {
		setSelectedCar(car)
		setShowCarAvailability(true)
	}

	const handleUpdateCarAvailability = async (car) => {
		try {
			await axios({
				method:  "PUT",
				url:     `${SERVER_URI}/update_vehicle_availability/${car.vehicleId}`,
				data:    {
					availableToDayShift:   car.availableToDayShift,
					availableToNightShift: car.availableToNightShift,
					availableToWeekendDayShift: car.availableToWeekendDayShift,
					availableToWeekendNightShift: car.availableToWeekendNightShift,
				},
				headers: {Authorization: `Token ${userToken}`},
			})
			alert("Ajoneuvon saatavuus päivitetty onnistuneesti!")
			setShowCarAvailability(false)
		} catch (e) {
			console.log(e.response.data.error)
			alert(`Virhe ajoneuvon saatavuuden päivityksessä:\n${e.response.data.error}`)
		}
	}

	console.log("Vehicle List:", props.vehicleList)

	return (<div className="drivers_cars_listing">
		<div>
			<h2>Kuljettajat ja Autot</h2>
			<AddForms dispatch={props.dispatch} priorityGroups={props.priorityGroups}/>
			<div className="sidenav">
				<a href="#drivers">Kuljettajat </a>
				<a href="#cars">Autot </a>
			</div>
			<div className="drivers_and_cars">
				<p id="drivers">Kuljettajat:</p>
				{props.driverList === undefined ? (<LoginRequest/>) : props.driverList.length === 0
				                                                      ? (<h4>Ei Kuljettajia</h4>)
				                                                      : (props.driverList.map((driver, index) => (<div
						className="drivers_list"
						key={index}
						id={driver.driverId}
						onClick={() => toggleComment(driver.driverId)}
					>
						{driver.name}
						<br/>
						<div className={show[driver.driverId] ? "showCar" : "hide"}>
							<span>Kuljettajan ID: </span>
							<br className="mobile-break"/> {driver.driverId} <br/>
							<div className="driverButtons">
								<Link to={`${URL_EXTENSION}drivers_and_cars/driver_reports/${driver.driverId}`}>
									<button id="gradient_Button">Kuljettajan ajetut vuorot</button>
								</Link>
								<button id="gradient_Button" onClick={() => deleteDriver(driver, index)}>
									Poista Kuljettaja
								</button>
								<button id="gradient_Button" onClick={() => handleResetDriversPassword(driver.driverId)}> Nollaa
									kuljettajan salasana
								</button>
							</div>
						</div>
					</div>)))}
			</div>
			<p id="cars">Autot:</p>
			{props.vehicleList === undefined ? (<LoginRequest/>) : props.vehicleList.length === 0
			                                                       ? (<h4>Ei Autoja</h4>)
			                                                       : (props.vehicleList.map((car, index) => (<div
					className="cars_list"
					key={`car${car.vehicleId}`}
					id={`car${car.vehicleId}`}
					onClick={() => toggleComment(`car${car.vehicleId}`)}
				>
					<span>Rekisterinumero: </span> {car.registerPlate}
					<div className={show[`car${car.vehicleId}`] ? "showCar" : "hide"}>
						<span>Ajoneuvon ID: </span>
						<br className="mobile-break"/> {car.vehicleId} <br/>
						<span>Puhelinnumero: </span>
						<br className="mobile-break"/> {car.phoneNumber}
						<br/>
						<span>Paikkojen määrä: </span> <br className="mobile-break"/>
						{car.numberOfSeats}
						<br/>
						<span>Prioriteettiryhmä: </span> <br className="mobile-break"/>
						{car.priorityGroup}
						<br/>
						<button id="gradient_Button" onClick={() => togglePopupCar(car, index)}>
							Muokkaa auton
							<br/> tietoja
						</button>
						<button id="gradient_Button" onClick={() => deleteCar(car, index)}>
							Poista Auto
						</button>
						<button id="gradient_Button" onClick={() => handleShowCarAvailability(car)}>Muokkaa auton saatavuutta
						</button>
					</div>
				</div>)))}
			{!isloggedIn && <LoginRequest/>}
			{isOpenCar && (<ChangeCarInfo
				index={editCarIndex}
				handleClose={togglePopupUpdateCar}
				carInfo={popupInfo}
				priorityGroups={props.priorityGroups}
				dispatch={props.dispatch}
			/>)}
			{showCarAvailability && (<CarShiftAvailabilityPopup
				car={selectedCar}
				handleClose={() => setShowCarAvailability(false)}
				open={showCarAvailability}
				handleUpdateVehicle={handleUpdateCarAvailability}
				/>) }
		</div>
	</div>)
}

const CarShiftAvailabilityPopup = (props) => {
	const {car, handleClose, open, handleUpdateVehicle} = props
	const [availableToDayShift, setAvailableToDayShift] = useState(car.availableToDayShift || false)
	const [availableToNightShift, setAvailableToNightShift] = useState(car.availableToNightShift || false)
	const [availableToWeekendDayShift, setAvailableToWeekendDayShift] = useState(car.availableToWeekendDayShift || false)
	const [availableToWeekendNightShift, setAvailableToWeekendNightShift] = useState(car.availableToWeekendNightShift || false)

	return (<Modal open={open} onClose={handleClose}>
		<Box style={{
			position:       "absolute",
			top:            "50%",
			left:           "50%",
			transform:      "translate(-50%, -50%)",
			width:          400,
			background:     "#fff",
			boxShadow:      24,
			padding:        32,
			display:        "flex",
			flexDirection:  "column",
			alignItems:     "center",
			justifyContent: "center",
			textAlign:      "center",
		}}>
			<Typography>Ajoneuvon id: {car.vehicleId}</Typography>
			<Typography>Rekisterinumero: {car.registerPlate}</Typography>
			<Box style={{display: "flex", flexDirection: "row", alignItems: "center"}}>
			<Typography>Käytettävissä päivävuoroon viikolla</Typography>
			<Checkbox checked={availableToDayShift} onChange={(e) => setAvailableToDayShift(e.target.checked)} />
			</Box>
			<Box style={{display: "flex", flexDirection: "row", alignItems: "center"}}>
				<Typography>Käytettävissä yövuoroon viikolla</Typography>
				<Checkbox checked={availableToNightShift} onChange={(e) => setAvailableToNightShift(e.target.checked)} />
			</Box>
			<Box style={{display: "flex", flexDirection: "row", alignItems: "center"}}>
				<Typography>Käytettävissä viikonloppupäivävuoroon</Typography>
				<Checkbox checked={availableToWeekendDayShift} onChange={(e) => setAvailableToWeekendDayShift(e.target.checked)} />
			</Box>
			<Box style={{display: "flex", flexDirection: "row", alignItems: "center"}}>
				<Typography>Käytettävissä viikonloppuyövuoroon</Typography>
				<Checkbox checked={availableToWeekendNightShift} onChange={(e) => setAvailableToWeekendNightShift(e.target.checked)} />
			</Box>
			<Box style={{display: "flex", flexDirection: "row", alignItems: "center"}}>
				<button id="gradient_Button" onClick={handleClose}>Sulje</button>
				<button id="gradient_Button" onClick={()=> handleUpdateVehicle({vehicleId: car.vehicleId, availableToDayShift, availableToNightShift, availableToWeekendDayShift, availableToWeekendNightShift })}>Tallenna</button>
			</Box>
		</Box>
	</Modal>)
}

export default CarsAndDrivers
